import Component from './DynamicComponent'
import SbEditable from 'storyblok-react'

import StoryblokClient from 'storyblok-js-client'

const Storyblok = new StoryblokClient({
    accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
    cache: {
      clear: 'auto',
      type: 'memory'
    }
})

const TermHead = ({term}) => {
  return (  
    <SbEditable content={term}>

      <h3 
      dangerouslySetInnerHTML={{__html:  
        term.text.type ? Storyblok.richTextResolver.render(term.text):term.text}}
      />

    </SbEditable>
)}

export default TermHead
